// extracted by mini-css-extract-plugin
module.exports = {"news_live":"news_live-2lplrh07 clearfix","stock_news":"stock_news-3qHDVk8H"};